import React from "react";
import {
  WiDaySunny,
  WiDayCloudy,
  WiCloudyWindy,
  WiDaySunnyOvercast,
} from "react-icons/wi";

const Weather = ({
  city,
  id,
  error,
  main,
  icon_id,
  celsius,
  temp_min,
  temp_max,
  description,
}) => {
  //storing day icons link
  const dayIcons = {
    clearsky: "https://www.flaticon.com/svg/static/icons/svg/2917/2917242.svg",
    fewclouds: "https://www.flaticon.com/svg/static/icons/svg/1146/1146795.svg",
    scatteredclouds:
      "https://www.flaticon.com/svg/static/icons/svg/3208/3208686.svg",
    overcastclouds:
      "https://www.flaticon.com/svg/static/icons/svg/121/121105.svg",
    brokenclouds:
      "https://www.flaticon.com/svg/static/icons/svg/414/414825.svg",
    showerRain:
      "https://www.flaticon.com/svg/static/icons/svg/2507/2507511.svg",
    rain: "https://www.flaticon.com/svg/static/icons/svg/1332/1332316.svg",
    drizzle: "https://www.flaticon.com/svg/static/icons/svg/1332/1332316.svg",
    thunderstorm:
      "https://www.flaticon.com/svg/static/icons/svg/2699/2699978.svg",
    snow: "https://www.flaticon.com/svg/static/icons/svg/3026/3026305.svg",
    mist: "https://www.flaticon.com/svg/static/icons/svg/3026/3026419.svg",
  };

  //storing night icons link
  const nightIcons = {
    clearsky: "https://www.flaticon.com/svg/static/icons/svg/2530/2530905.svg",
    fewclouds: "https://www.flaticon.com/svg/static/icons/svg/1152/1152393.svg",
    scatteredclouds:
      "https://www.flaticon.com/svg/static/icons/svg/2929/2929984.svg",
    overcastclouds:
      "https://www.flaticon.com/svg/static/icons/svg/121/121105.svg",
    brokenclouds:
      "https://www.flaticon.com/svg/static/icons/svg/121/121105.svg",
    drizzle: "https://www.flaticon.com/svg/static/icons/svg/1150/1150559.svg",
    rain: "https://cdn.onlinewebfonts.com/svg/img_541491.png",
    thunderstorm:
      "https://www.flaticon.com/svg/static/icons/svg/2272/2272198.svg",
    snow: "https://www.flaticon.com/svg/static/icons/svg/578/578144.svg",
    mist: "https://www.flaticon.com/svg/static/icons/svg/727/727890.svg",
  };
  // check to find day or night
  const dayOrNight = icon_id.replace(/[0-9]/g, "");
  //  Weather Property
  const weatherType = description.replace(" ", "");
  //
  switch (true) {
    case id === 800:
      id = dayOrNight === "d" ? dayIcons["clearsky"] : nightIcons["clearsky"];
      break;
    case id >= 200 && id < 232:
      id =
        dayOrNight === "d"
          ? dayIcons["thunderstorm"]
          : nightIcons["thunderstorm"];
      break;
    case id >= 300 && id <= 321:
      id = dayOrNight === "d" ? dayIcons["drizzle"] : nightIcons["drizzle"];
      break;
    case id >= 500 && id <= 521:
      id = dayOrNight === "d" ? dayIcons["rain"] : nightIcons["rain"];
      break;
    case id >= 600 && id <= 622:
      id = dayOrNight === "d" ? dayIcons["snow"] : nightIcons["snow"];
      break;
    case id >= 701 && id <= 781 && id !== 800:
      id = dayOrNight === "d" ? dayIcons["mist"] : nightIcons["mist"];
      break;
    case id >= 801 && id <= 804:
      id =
        dayOrNight === "d"
          ? dayIcons["brokenclouds"]
          : nightIcons["brokenclouds"];
      break;
  }

  return (
    <div className="contain mx-auto">
      <div className="cards">
        <p className="w-70 h-70 ">{`${city}`}</p>

        {error === false ? svgAndCel(id, celsius) : ""}
        {/* min and max Temp */}
        {temp_min === temp_max ? "" : minmaxTemp(temp_min, temp_max)}
        <p className="py-3">{description.toUpperCase()}</p>
      </div>
    </div>
  );
};
const minmaxTemp = (min, max) => {
  return (
    <h3>
      <span className="px-4">{min}&deg;</span>
      <span className="px-4">{max}&deg;</span>
    </h3>
  );
};
const svgAndCel = (id, celsius) => {
  return (
    <div>
      <img className="icon" src={id} alt="Noting" />
      <p className="cel">{celsius}&deg;</p>
    </div>
  );
};
export default Weather;
